import { createContext, useContext, useEffect, useState } from "react";
import { restoreSession, logout as apiLogout, getActiveProfile } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  // On app load, try to restore the session from the httpOnly refresh cookie.
  useEffect(() => {
    let alive = true;
    restoreSession()
      .then(async (u) => {
        if (!alive) return;
        setUser(u);
        // Refresh the local profile cache that synchronous readers (Analysis,
        // Navbar) rely on after a page reload.
        if (u) { try { await getActiveProfile(); } catch {} }
      })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, []);

  async function logout() {
    await apiLogout();
    setUser(null);
  }

  return (
    <AuthContext.Provider value={{ user, setUser, loading, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
